import * as z from 'zod';
import { validaNomeCompleto } from '../../../../utils/ValidaNome';

export const dependentsSchema = z.object({
  name: z.string().refine(val => validaNomeCompleto(val), {
    message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
  }),
  civilStatus: z.string().optional(),
  gender: z.string(),
  parentage: z.number(),
  plano: z.number(),
  plano_vl: z.optional(z.string()),
});
